<template>
    <div>
        <b-form-group label="Cliente" label-for="client">
            <b-form-input v-model="localClient" placeholder="Cliente" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        client: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localClient: {
            get() {
                return this.client
            },
            set(value) {
                this.$emit('update', {client: value})
            },
        },
    },
}
</script>
